GLightbox({ selector: '.slide-historia .glightbox' });

const swiperHistoria = new Swiper('.slide-historia', {
  slidesPerView: 1.5, // ✅ MOBILE
  spaceBetween: 24,
  centeredSlides: false,
  loop: false,

  navigation: {
    nextEl: '.arrow-next',
    prevEl: '.arrow-prev',
  },

  breakpoints: {
    768: {
      slidesPerView: 3.2,
    },
    992: {
      slidesPerView: 4.2,
    },
    1200: {
      slidesPerView: 5.4,
    }
  }
});